import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { useRequestFormReviewValidation } from "@RequestFormV2/context/reviewValidation";
import { hasLeafReviewError } from "@RequestFormV2/validation/utils/hasLeafReviewError";

export function useReactiveReviewClear(
  errorPath: string,
  shouldClear: () => boolean,
  deps: unknown[],
  enabled = true,
) {
  const { hasAttemptedReview, clearFieldError } = useRequestFormReviewValidation();
  const {
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    if (!enabled || !hasAttemptedReview || !clearFieldError) return;
    if (!hasLeafReviewError(errors, errorPath)) return;
    if (shouldClear()) {
      clearFieldError(errorPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, hasAttemptedReview, clearFieldError, errors, errorPath, ...deps]);
}
